const KEYS = {
  VISITED: "ai_creatives_visited",
  GENERATIONS: "ai_creatives_generations",
};

export function hasVisited() {
  return localStorage.getItem(KEYS.VISITED) === "true";
}

export function markVisited() {
  localStorage.setItem(KEYS.VISITED, "true");
}

export function getGenerations() {
  try {
    const raw = localStorage.getItem(KEYS.GENERATIONS);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function saveGeneration(generation) {
  const list = getGenerations();
  const updated = [generation, ...list].slice(0, 50);
  localStorage.setItem(KEYS.GENERATIONS, JSON.stringify(updated));
  return updated;
}

export function updateGeneration(id, patch) {
  const list = getGenerations();
  const updated = list.map((g) => (g.id === id ? { ...g, ...patch } : g));
  localStorage.setItem(KEYS.GENERATIONS, JSON.stringify(updated));
  return updated;
}

export function clearGenerations() {
  localStorage.removeItem(KEYS.GENERATIONS);
}

export function sanitizeFormDataForStorage(formData) {
  if (!formData) return formData;
  const { referenceImageDataUrls, ...rest } = formData;
  const n = Array.isArray(referenceImageDataUrls) ? referenceImageDataUrls.length : 0;
  return n ? { ...rest, referenceImagesCount: n } : rest;
}
